<template>
    <modal
        name="opciones-bloqueos"
        transition="pop-out"
        :width="800"
        height="auto"
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row">
                    <div class="col-10">
                        <h2>Opciones de bloqueos</h2>
                    </div>
                    <div class="col-2">
                        <button type="button" class="close" @click.prevent="close()">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <form>
                        <div class="col-12">
                            <div class="custom-control custom-checkbox">
                                <input @change="update" class="custom-control-input" id="can_change_seat" type="checkbox" name="can_change_seat" v-model="can_change_seat">
                                <label class="custom-control-label" for="can_change_seat">Los abonados pueden cambiar de asiento al renovar de manera online</label>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="card-footer text-right">
                <Button type="button" name="button" @click.prevent="close()">CERRAR</Button>
            </div>
        </div>
    </modal>
</template>

<script>

export default {
    props: [],
    data() {
        return {
            can_change_seat: 0
        }
    },
    created() {
        this.can_change_seat = this.lista.can_change_seat;
    },
    computed: {
        lista() {
            return this.$store.getters.getListaActiva;
        }
    },
    methods: {
        close() {
            this.$emit('close', 'opciones-bloqueos');
        },
        update() {
            const params = {
                filters: {
                    lista_id: this.$store.getters.getListaId
                },
                lista_id: this.$store.getters.getListaId,
                can_change_seat: this.can_change_seat
            }

            this.$store.dispatch(this.config.getVuexAlias('back.lista.editar'), params);
        }
    }
}
</script>
